import React, { useState, useEffect } from 'react';

import Axios from 'axios';

import FlexContainer from '@components/Gui/FlexContainer';
import { Loading } from '@components/Gui/Loading';
import NwDrawer from '@components/Gui/NwDrawer';
import MediaPreview from '@components/MediaDrawer/MediaPreview';

const MediaDrawerPreviewOnly = ({ mediaID, pdfPath, onCloseDrawer }) => {
    const [document, setDocument] = useState(null);

    const getMedia = async () => {
        const documentData = await Axios.get(`/documents/${mediaID}`);
        setDocument(documentData);
    };
    useEffect(() => {
        if (mediaID) {
            getMedia();
        }
    }, [mediaID]);

    return (
        <NwDrawer
            width={window.innerWidth > 876 ? '70vw' : '100%'}
            title={
                <FlexContainer justifyContent="space-between">
                    <div>Media Details</div>
                </FlexContainer>
            }
            onClose={() => onCloseDrawer(document)}
            whiteBg={false}
        >
            <div className="drawer-content">
                {document || pdfPath ? (
                    <div id="drawerContentContainer">
                        <div>
                            <MediaPreview document={document} fullHeight pdfPath={pdfPath} />
                        </div>
                    </div>
                ) : (
                    <Loading />
                )}
            </div>
        </NwDrawer>
    );
};

export default MediaDrawerPreviewOnly;
